import { useState } from 'react';
import './Navigation.css';

const navigationItems = [
  { anchor: '#hero', label: 'Home' },
  { anchor: '#experience', label: 'Experience' },
  { anchor: '#story', label: 'Story' },
  { anchor: '#contact', label: 'Contact' },
];

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (anchor: string) => {
    document.querySelector(anchor)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation" aria-label="Primary navigation">
      <div className="nav-container">
        <button className="nav-logo" onClick={() => scrollToSection('#hero')}>Rafael Perales</button>
        <button className="menu-toggle" onClick={() => setIsMenuOpen((open) => !open)} aria-label="Toggle menu" aria-expanded={isMenuOpen}>Menu</button>
        <ul className={`nav-links ${isMenuOpen ? 'nav-links-open' : ''}`}>
          {navigationItems.map((item) => (
            <li key={item.anchor}><button onClick={() => scrollToSection(item.anchor)}>{item.label}</button></li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
